import React, { ReactNode } from 'react';

export type ToastKind = 'default' | 'accent';

export type ToastProps = {
  visible: boolean;
  children?: ReactNode;
  kind?: ToastKind;
  icon?: ReactNode;
};

export function Toast({ visible, children, kind = 'default', icon }: ToastProps) {
  return (
    <div
      style={{
        position: 'fixed', bottom: 32, left: '50%',
        transform: `translateX(-50%) translateY(${visible ? 0 : 20}px)`,
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        background: kind === 'default' ? 'rgba(28, 28, 30, 0.92)' : 'var(--accent)',
        color: '#fff',
        padding: '12px 18px',
        borderRadius: 999,
        fontSize: 14, fontWeight: 500,
        display: 'inline-flex', alignItems: 'center', gap: 8,
        boxShadow: 'var(--shadow-3)',
        backdropFilter: 'blur(20px)',
        transition: 'transform var(--dur-base) var(--ease-spring), opacity var(--dur-base) var(--ease-out)',
        zIndex: 200,
      }}
      role="status"
      aria-live="polite"
    >
      {icon}
      {children}
    </div>
  );
}

export default Toast;
